import React from "react";
import styles from "./StudTalks.module.css";

const StudTalks = () => {
  // WhatsApp link for registration - REPLACE WITH YOUR ACTUAL NUMBER
  const whatsappNumber = "919876543210"; // Change this to your WhatsApp number
  
  // Upcoming topics data - now only 3 topics
  const upcomingTopics = [
    {
      id: 1,
      topic: "Time Management for UPSC Preparation",
      date: "March 15, 2026",
      time: "6:00 PM - 7:00 PM",
      host: "Prabhash Sir",
      spotsLeft: 8,
      totalSpots: 15,
      description: "Share your time management strategies and learn from peers"
    },
    {
      id: 2,
      topic: "Answer Writing Techniques for Mathematics Optional",
      date: "March 22, 2026",
      time: "6:00 PM - 7:00 PM",
      host: "Asha Mam",
      spotsLeft: 5,
      totalSpots: 15,
      description: "Discuss effective answer writing approaches for maths optional"
    },
    {
      id: 3,
      topic: "Managing Stress During Preparation",
      date: "March 29, 2026",
      time: "6:00 PM - 7:00 PM",
      host: "Guest Speaker",
      spotsLeft: 12,
      totalSpots: 15,
      description: "Share coping mechanisms and mental wellness strategies"
    }
  ];

  // Past topics with reviews
  const pastTopics = [
    {
      id: 1,
      topic: "How to Approach Complex Problems in Mathematics",
      date: "March 1, 2026",
      participants: 14,
      host: "Prabhash Sir",
      highlights: "Great discussion on problem-solving frameworks"
    },
    {
      id: 2,
      topic: "Building Consistency in Daily Study Routine",
      date: "February 22, 2026",
      participants: 12,
      host: "Asha Mam",
      highlights: "Students shared practical tips for maintaining consistency"
    },
    {
      id: 3,
      topic: "Selecting Optional Subject: Mathematics vs Others",
      date: "February 15, 2026",
      participants: 15,
      host: "Prabhash Sir",
      highlights: "Comprehensive discussion on pros and cons of maths optional"
    },
    {
      id: 4,
      topic: "Mock Test Analysis: How to Improve Scores",
      date: "February 8, 2026",
      participants: 13,
      host: "Guest Speaker",
      highlights: "Effective techniques for test analysis and improvement"
    }
  ];

  // Handle WhatsApp registration
  const handleWhatsAppRegister = (topicName) => {
    const message = `Hi, I want to register for STUD Talks session on: ${topicName}`;
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/${whatsappNumber}?text=${encodedMessage}`, "_blank");
  };

  return (
    <div className={styles.studTalksPage}>
      {/* Hero Section - Simplified */}
      <section className={styles.heroSection}>
        <div className={styles.container}>
          <div className={styles.heroContent}>
            <h1 className={styles.heroTitle}>
              <span className={styles.gradientText}>STUD Talks</span>
            </h1>
            <p className={styles.heroSubtitle}>
              A weekly platform for students to share thoughts, express ideas, and get detailed feedback from experts
            </p>
          </div>
        </div>
      </section>

      {/* Upcoming Topics Section - 3 in a row */}
      <section className={styles.upcomingSection}>
        <div className={styles.container}>
          <div className={styles.sectionHeaderCenter}>
            <h2>Upcoming <span className={styles.gradientText}>Topics</span></h2>
            <p className={styles.sectionDesc}>Register via WhatsApp to secure your slot</p>
          </div>

          <div className={styles.topicsGrid}>
            {upcomingTopics.map((topic) => (
              <div key={topic.id} className={styles.topicCard}>
                <div className={styles.topicCardHeader}>
                  <h3>{topic.topic}</h3>
                  <div className={styles.spotsBadge}>
                    {topic.spotsLeft} spots left
                  </div>
                </div>
                
                <div className={styles.topicDetails}>
                  <div className={styles.detailItem}>
                    <i className="fas fa-calendar"></i>
                    <span>{topic.date}</span>
                  </div>
                  <div className={styles.detailItem}>
                    <i className="fas fa-clock"></i>
                    <span>{topic.time}</span>
                  </div>
                  <div className={styles.detailItem}>
                    <i className="fas fa-user-tie"></i>
                    <span>Host: {topic.host}</span>
                  </div>
                </div>

                <p className={styles.topicDescription}>{topic.description}</p>

                <button 
                  className={styles.registerBtn}
                  onClick={() => handleWhatsAppRegister(topic.topic)}
                >
                  <i className="fab fa-whatsapp"></i>
                  Register on WhatsApp
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Past Topics Section */}
      <section className={styles.pastSection}>
        <div className={styles.container}>
          <div className={styles.sectionHeaderCenter}>
            <h2>Past <span className={styles.gradientText}>Sessions</span></h2>
          </div>

          <div className={styles.pastGrid}>
            {pastTopics.map((topic) => (
              <div key={topic.id} className={styles.pastCard}>
                <div className={styles.pastCardHeader}>
                  <h3>{topic.topic}</h3>
                  <span className={styles.pastDate}>{topic.date}</span>
                </div>
                <div className={styles.pastDetails}>
                  <span><i className="fas fa-user-tie"></i> {topic.host}</span>
                  <span><i className="fas fa-users"></i> {topic.participants} participated</span>
                </div>
                <p className={styles.pastHighlights}>
                  <i className="fas fa-star"></i>
                  {topic.highlights}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default StudTalks;